import React, {Component} from 'react'
import '../../../styles/Admin.css'
import {Button} from "react-bootstrap";
import {Editor} from 'react-draft-wysiwyg'
import {ContentState, convertFromHTML, convertToRaw, EditorState} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import AdminGaleria from "../AdminGaleria";
import Modal from "react-modal";
import AdminService from "../AdminService";


export default class EdytujEvent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tytul: this.props.item.tytul,
            tresc: EditorState.createEmpty(),
            opis: '',
            modalIsOpen: false,
            zdjecie: [],
            zdjecieShow: [],
            zdjecieShowZapisane: [],
            opublikowano: this.props.item.opublikowano,
        };

        this.handleTytulChange = this.handleTytulChange.bind(this);
        this.handleTrescChange = this.handleTrescChange.bind(this);
        this.handleOpisChange = this.handleOpisChange.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

    }

    componentWillMount() {
        AdminService.getStronaById(this.props.item.id)
            .then(function (response) {
                let tresc = EditorState.createEmpty();
                if (response.data.tresc !== null && response.data.tresc !== '' && response.data.tresc.length !== 8 && response.data.tresc !== '<p></p>↵') {

                    const blocksFromHTML = convertFromHTML(
                        response.data.tresc
                    );

                    const content = ContentState.createFromBlockArray(
                        blocksFromHTML.contentBlocks,
                        blocksFromHTML.entityMap
                    );

                    tresc = EditorState.createWithContent(content);
                }

                let zdjecie = [];

                if (response.data.pliki.length !== null) {
                    zdjecie = response.data.pliki
                }

                this.setState({
                    loading: false,
                    tytul: response.data.tytul,
                    tresc: tresc,
                    opublikowano: response.data.aktywny,
                    zdjecieShowZapisane: zdjecie
                })

            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }


    onEditorStateChange = (editorState) => {
        this.setState({
            tresc: editorState,
        });
    };

    handleTytulChange(e) {
        this.setState({tytul: e.target.value})
    }

    handleTrescChange(e) {
        this.setState({tresc: e.target.value})
    }

    handleOpisChange(e) {
        this.setState({opis: e.target.value})
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({zdjecieInvalid: true, zdjecie: '', zdjecieShow: ''})
        } else {
            this.setState({zdjecieInvalid: false, zdjecie: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState(prevState => ({
                zdjecieShow: [...prevState.zdjecieShow, {
                    dane: reader.result.split(",")[1],
                    nazwa: file[0].name,
                    dokumentTyp: "STRONA_WPIS",
                    typ: file[0].type,
                    rozmiar: file[0].size,
                }]
            }));
            this.setState({zdjecie: '', opis: ''});
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    deleteImageZapisany(image) {
        AdminService.deletePlikAdmin(image.id)
            .then(function (response) {
                let images = this.state.zdjecieShowZapisane;
                images = images.filter(el => el !== image);
                this.setState({zdjecieShowZapisane: images});
                alert('Zdjęcie zostało usunięte z serwera')
            }.bind(this))
    }

    deleteImage(image) {
        let images = this.state.zdjecieShow;
        images = images.filter(el => el !== image);
        this.setState({zdjecieShow: images})
    }


    uploadNews() {
        AdminService.putStrona(this.props.item.id, "EVENT", this.state.tytul, draftToHtml(convertToRaw(this.state.tresc.getCurrentContent())), this.state.opublikowano, null, this.state.zdjecieShow)
            .then(function (response) {
                this.props.goZarzadzanie()
            }.bind(this))
    }

    render() {
        return <div className="aktualnosciTabContainer">
            <Modal
                isOpen={this.state.modalIsOpen}
                onRequestClose={this.closeModal}
                contentLabel="Biblioteka mediów"
                style={{
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                }}
            >
                <AdminGaleria modal={true} container={true} closeModal={() => this.closeModal()}
                              wybierzObraz={(obraz) => {
                                  this.getBase64(obraz);
                                  this.closeModal()
                              }}/>
            </Modal>
            <div className="aktualnosciOpis">
                Aby edytować wpis należy zmienić wybrane do zmiany pola, oraz zdjęcia. Wpis można później edytować
                ponownie
                przez zakładkę
                <span style={{cursor: 'pointer'}} onClick={() => this.props.goZarzadzanie()}>
                    <b> zarządzanie</b>
                </span>.
            </div>
            <div className="nowyWpisForm">
                <div className="field">Tytuł:
                    <input type="text" value={this.state.tytul} maxLength={100} onChange={this.handleTytulChange}
                           className="form-control"/></div>
                <div className="field">Treść:
                    <Editor
                        editorState={this.state.tresc}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperEditor"
                        editorClassName="editorEditor"
                        onEditorStateChange={this.onEditorStateChange}
                    /></div>
                <div className="field">
                    <div className="row">
                        <div className="col-sm-6">
                            Dodaj zdjęcie:
                            <div
                                onClick={this.state.zdjecieShowZapisane === [] || (this.state.zdjecieShowZapisane.length + this.state.zdjecieShow.length) < 1 ? () => this.openModal() : null}
                                style={{
                                    marginTop: 15,
                                    height: 150,
                                    width: '90%',
                                    padding: 50,
                                    textAlign: 'center',
                                    border: '1px dashed #ced4da',
                                    borderRadius: '.25rem',
                                    cursor: 'pointer'
                                }}>
                                {this.state.zdjecieShowZapisane === [] || (this.state.zdjecieShowZapisane.length + this.state.zdjecieShow.length) < 1 ? 'Kliknij by otworzyć menedżer plików' : 'Osiągnięto maksymalną ilość obrazków dla slajdu (1)'}</div>
                        </div>
                        <div className="col-sm-6" style={{borderLeft: '1px solid #eaeaea'}}>
                            Dodane zdjęcia:
                            <div className={'row'}>
                                <div className={'row'}>
                                    {this.state.zdjecieShowZapisane.map((item, i) => {
                                        return <div className='col-4 text-center imageBorderNowyWpis'>
                                            <i className="fa fa-times"
                                               style={{color: 'red', float: 'right', paddingTop: 10, cursor: 'pointer'}}
                                               onClick={() => this.deleteImageZapisany(item)}> </i>
                                            <img
                                                src={'data:' + this.state.zdjecieShowZapisane[0].typ + ';base64, ' + this.state.zdjecieShowZapisane[0].dane}
                                                width={'60%'}/>
                                        </div>
                                    })}
                                    {this.state.zdjecieShow.map((item, i) => {
                                        return <div className='col-4 text-center imageBorderNowyWpis'>
                                            <i className="fa fa-times"
                                               style={{color: 'red', float: 'right', paddingTop: 10, cursor: 'pointer'}}
                                               onClick={() => this.deleteImage(item)}> </i>
                                            <img
                                                src={'data:' + this.state.zdjecieShow[0].typ + ';base64, ' + this.state.zdjecieShow[0].dane}
                                                width={'60%'}/>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <div className="text-right">
                    <span style={{width: 105, textAlign: 'center'}}>Publikacja:
                        <input type={'checkbox'} style={{marginLeft: 5, marginRight: 10, paddingTop: 3}}
                               checked={this.state.opublikowano}
                               onChange={() => this.setState({opublikowano: !this.state.opublikowano})}/>
                    </span>
                    <Button bsStyle={'success'} onClick={() => this.uploadNews()}>Aktualizuj event</Button>
                </div>
            </div>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/eventyComponents/EdytujEvent.js